import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import IconButton from "../Components/IconButton";

import { useTranslation } from "react-i18next";

import { createMarkup } from "../Helpers/htmlHelper";

const Testimonial_Detail = ({ storyNumber, image, backdropColor, bodyColor, onToTopClick }) => {
  const { t } = useTranslation();

  const textFirst = storyNumber % 2 !== 0;
  const bgColor = storyNumber % 2 !== 0 ? "blue-25" : "blue-50";
  // Determine order of the columns based on textFirst
  const textColumnOrder = textFirst ? 1 : 2;
  const imageColumnOrder = textFirst ? 2 : 1;

  const total = 6;

  const btnH = 3.25;
  const borderH = 0.25;
  const fixH = (btnH - borderH) / 2;
  const fixT = storyNumber === 0 ? 0 : fixH;
  const fixB = storyNumber === total ? borderH : fixH;

  const paddingXs = 3.125;
  const paddingMd = 4.125;
  const paddingXsT = paddingXs - fixT;
  const paddingMdT = paddingMd - fixT;
  const paddingXsB = paddingXs + fixB;
  const paddingMdB = paddingMd + fixB;
  const cl = `mt-mts_${paddingXsT} mb-mts_${paddingXsB} mt-lg-mts_${paddingMdT} mb-lg-mts_${paddingMdB}`.replaceAll(".", "_");

  return (
    <>
      <div className={`text-${bodyColor} text-center text-md-start py-mts_4_375 py-md-mts_6_25`}>
        <Container>
          <Row>
            <Col xs={12} md={textFirst ? 7 : { span: 7, offset: 1 }} className="my-auto" style={{ order: textColumnOrder }}>
              <span className={`text-primary-dark-blue section_header text-uppercase d-block mb-auto`}>{t(`careers_story_${storyNumber}_name`)}</span>
              <span className="text-primary-dark-blue text-uppercase subtitle d-block mb-auto">{t(`careers_story_${storyNumber}_function`)}</span>
              <h2 className={`my-mts_1 text-primary-dark-blue`} dangerouslySetInnerHTML={createMarkup(t(`careers_story_${storyNumber}_heading`))}></h2>
              {/* For 4 questions */}
              {[1, 2, 3, 4].map((questionNumber) => (
                <div key={questionNumber} className="row">
                  <div className="col-12">
                    <p className="mb-0 text-primary-dark-blue text-uppercase subtitle d-block mb-auto">{t(`careers_story_question_${questionNumber}`)}</p>
                    <p>{t(`careers_story_${storyNumber}_answer_${questionNumber}`)}</p>
                  </div>
                </div>
              ))}
              <div className="mt-5 mb-3 mt-md-mts_2 mb-md-0 hstack gap-mts_2 align-items-stretch align-items-center">
                <Button variant={`${backdropColor}`} size="sm" className="align-items-center" onClick={() => window.open("/careers")}>
                  {t("careers_story_cta")}
                </Button>
              </div>
            </Col>
            <Col xs={12} md={textFirst ? { span: 4, offset: 1 } : 4} className="d-flex align-items-start" style={{ order: imageColumnOrder }}>
              <div className={`image-container ${backdropColor}`} style={{ "--image-url": `url(${image})` }}>
                <img src={image} className="img-fluid" alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid className="g-0 position-absolute bottom-0" style={{ height: `${storyNumber === total ? borderH : btnH}rem` }}>
        <div
          className={`bg-${backdropColor} position-absolute top-50 start-0 translate-middle-y`}
          style={{ width: `${(storyNumber / total) * 100}%`, height: `${borderH}rem` }}
        ></div>
        <Container className="d-flex position-absolute top-50 start-50 translate-middle">
          <IconButton iconAfter="chevron-up" size="sm" className={`ms-auto btn-${backdropColor} p-3`} onClick={onToTopClick}></IconButton>
        </Container>
      </Container>
    </>
  );
};

export default Testimonial_Detail;
